/**
 * Local development / UI testing — enable via `.env.development.local` (gitignored):
 *
 *   VUE_APP_DEV_SKIP_BOOTSTRAP=true
 *   VUE_APP_DEV_SKIP_AUTH=true
 *
 * `vue-cli-service serve` loads `.env.development` and `.env.development.local`.
 */
export const devSkipBootstrap =
  process.env.VUE_APP_DEV_SKIP_BOOTSTRAP === 'true'

export const devSkipAuth =
  process.env.VUE_APP_DEV_SKIP_AUTH === 'true'
